import React, {Component} from "react";
import {AutoComplete} from "primereact/autocomplete";
import RemotingService from "../../../services/remoting-service/RemotingService";

export default class AppointmentCptSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cptList: this.props.cptList || [],
            cptCodeSuggestions: []
        };
    }

    add = (cpt) => {
        const cptList = [...this.state.cptList, cpt];
        this.setState({cptList});
        this.props.onCptSelected(cptList);
    }

    remove = (cpt) => {
        const cptList = this.state.cptList.filter(i => i.id !== cpt.id);
        this.setState({cptList});
        this.props.onCptSelected(cptList);
    }

    cptCodeSearch = (event) => {
        const params = {
            scopes: ["ALL", "SELF_PAY"],
            speciality: this.props.staff?.specialityName || this.props.staff?.speciality?.name,
            modality: this.props.roomName
        };
        
        RemotingService.getRemoteCall(`api/cpt/code-or-description/${this.props.clinicCountry}`, params, cptCodes => {
            const filtered = cptCodes.filter(cpt => {
                const query = event.query.toLowerCase();
                return (cpt.cptCode && cpt.cptCode.toLowerCase().includes(query)) ||
                       (cpt.description && cpt.description.toLowerCase().includes(query));
            });
            
            const selectedIds = this.state.cptList.map(cpt => cpt.id);
            const availableCptCodes = filtered.filter(cpt => !selectedIds.includes(cpt.id));
            
            availableCptCodes.forEach(cpt => cpt.label = (cpt.cptCode || cpt.description));
            this.setState({cptCodeSuggestions: availableCptCodes});
        });
    }

    render() {
        return (
            <div style={{position: 'relative'}}>
                <AutoComplete
                    placeholder="Search CPT codes..."
                    minLength={2}
                    multiple
                    field="cptCode"
                    value={this.props.cptList}
                    disabled={false}
                    onChange={event => {
                        this.setState({cpt: event.value})
                    }}
                    onSelect={event => {
                        this.add(event.value);
                    }}
                    onUnselect={event => {
                        this.remove(event.value);
                    }}
                    suggestions={this.state.cptCodeSuggestions}
                    completeMethod={this.cptCodeSearch}
                    itemTemplate={cpt =>
                        <span>{cpt.cptCode} - {cpt.description}</span>}
                />
            </div>
        );
    }
}
